import React, { useState } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { user, login, error } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user === null) {
    return (
      <div className="min-h-screen bg-[var(--pc-bg)] flex items-center justify-center">
        <Loader2 className="text-[var(--pc-bronze)] animate-spin" />
      </div>
    );
  }
  if (user) {
    const target = location.state?.from || "/admin";
    return <Navigate to={target} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) navigate(location.state?.from || "/admin", { replace: true });
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen bg-[var(--pc-bg)] flex items-center justify-center px-6"
    >
      <form
        onSubmit={onSubmit}
        className="w-full max-w-[420px] border border-[var(--pc-line)] bg-[#0b0b0d] p-10"
        data-testid="admin-login-form"
      >
        <div
          className="text-[var(--pc-bronze)]"
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 400,
            fontSize: 11,
            letterSpacing: "0.34em",
            textTransform: "uppercase",
          }}
        >
          Panel
        </div>
        <h1
          className="headline-xl mt-3 text-[var(--pc-text)]"
          style={{ fontSize: "clamp(24px, 2.4vw, 32px)", letterSpacing: "0.16em", lineHeight: 1.2 }}
        >
          Paco Cabrera
        </h1>
        <div className="h-px w-10 bg-[var(--pc-bronze)] mt-6 opacity-90" />

        <div className="mt-10 space-y-5">
          <div>
            <label className="admin-label">Correo</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="admin-input w-full"
              data-testid="login-email"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="admin-label">Contraseña</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="admin-input w-full"
              data-testid="login-password"
              autoComplete="current-password"
            />
          </div>
        </div>

        {error && (
          <p className="text-xs text-red-400 mt-5" data-testid="login-error">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={busy}
          className="admin-btn-primary w-full mt-8 flex items-center justify-center gap-2"
          data-testid="login-submit"
        >
          {busy && <Loader2 size={14} className="animate-spin" />}
          <span>{busy ? "Entrando..." : "Entrar"}</span>
        </button>
      </form>
    </main>
  );
}
